<template>
  <div class="search-filter-header">
    <div class="row">
      <div class="col-8 d-flex align-items-center">
        <div class="multiple-options-selection">
          <div
            class="handler d-flex align-items-center justify-content-between form-control"
            @click.stop="toggleFilterMenu"
          >
            <div class="selected-option-count" v-if="false">
              {{ filter_options.filter((each) => each.selected).length }}
            </div>
            <div class="place-holder">
              {{ filter_options?.find((each) => each.selected)?.label }}
            </div>
            <img
              :src="require(`@/assets/images/icons/chevron-down.svg`)"
              alt="chevron-down"
              :style="{ transform: open_filter_menu ? 'rotate(180deg)' : '' }"
            />
          </div>
          <div
            v-if="open_filter_menu"
            v-click-outside="toggleFilterMenu"
            class="options p-3"
            :style="
              isLangRtl ? 'right: 0px; width: 220px' : 'left: 0px; width: 220px'
            "
          >
            <div
              v-if="false"
              class="option d-flex align-items-center cursor-pointer mb-2 pb-2"
              @click="selectAllFilterOption"
            >
              <input type="checkbox" name="all" :checked="select_all" />
              <div class="ms-2">
                {{ $t("all") }}
              </div>
            </div>
            <div
              v-for="(option, index) in filter_options"
              :key="index"
              :class="
                index < filter_options.length - 1
                  ? 'option d-flex align-items-center cursor-pointer mb-2 pb-2'
                  : 'cursor-pointer'
              "
              @click="selectSingleFilterOption(option)"
            >
              <input
                v-if="false"
                type="checkbox"
                :name="option.key"
                :checked="option.selected"
                class="me-2"
              />
              <div>
                {{ option?.label }}
              </div>
            </div>
            <div
              v-if="false"
              class="d-flex align-items-center cursor-pointer mt-2"
              @click="resetFilterSelection"
            >
              <img
                :src="require('@/assets/images/icons/trash-icon.svg')"
                alt="delete image"
                class="me-2"
              />
              <div>
                {{ $t("reset-selection") }}
              </div>
            </div>
          </div>
        </div>
        <div class="mx-2">
          <base-input
            cus_style="width:300px"
            :remove_default_margin="true"
            id="client-list-search-text"
            placeholder="search-here"
            field="search_text"
            :value="search_text"
            @change-value="setValue"
            @enter="search"
          />
        </div>
        <div>
          <base-button
            variant="primary"
            id="client-list-search-btn"
            @click="search"
          >
            {{ $t("search") }}
          </base-button>
        </div>
      </div>
      <div class="col-4 d-flex align-items-center justify-content-end">
        <div class="me-2">
          <base-button
            cus_style="padding:8px 20px"
            variant="secondary"
            :class="[
              'add-btn py-2 px-4',
              {
                'not-allowed':
                  this.$store.getters['enums/is_not_permitted']('addClient'),
              },
            ]"
            :loading="export_loading"
            @click="$emit('showExportPopup')"
          >
            {{ $t("export") }}
            <img
              class="export-icon ms-2"
              src="@/assets/images/icons/export-icon.svg"
            />
          </base-button>
        </div>
        <div class="me-2">
          <base-button
            cus_style="padding:8px 20px"
            variant="secondary"
            :class="[
              'add-btn py-2 px-4',
              {
                'not-allowed':
                  this.$store.getters['enums/is_not_permitted']('addClient'),
              },
            ]"
            @mouseenter="AddBtnHovered = true"
            @mouseleave="AddBtnHovered = false"
            @click="MoveToAddClient"
          >
            <img
              :src="
                AddBtnHovered
                  ? require(`@/assets/images/icons/add-icon.svg`)
                  : require(`@/assets/images/icons/add-icon.svg`)
              "
              alt="plus icon"
            />
            <div class="mx-2">{{ $t("add-client") }}</div>
          </base-button>
        </div>
        <div class="me-2">
          <img
            class="cursor-pointer"
            :style="`opacity:${selected_view === 'table' ? 1 : 0.3}`"
            :src="require('@/assets/images/icons/new-list-icon.svg')"
            alt="list"
            @click="$emit('selectView', 'table')"
          />
        </div>
        <div>
          <img
            class="cursor-pointer"
            :style="`opacity:${selected_view === 'grid' ? 1 : 0.3}`"
            :src="require('@/assets/images/icons/grid-icon.svg')"
            alt="grid"
            @click="$emit('selectView', 'grid')"
          />
        </div>
      </div>
    </div>
    <b-alert
      :show="export_error && export_error.length ? true : false"
      variant="danger"
      class="mt-2"
    >
      <div v-if="Array.isArray(export_error)">
        <div
          class="d-flex flex-column my-1"
          v-for="(error_text, index) in export_error"
          :key="index"
        >
          {{ error_text }}
        </div>
      </div>
      <div v-else>
        <div v-html="export_error || '&nbsp;'"></div>
      </div>
    </b-alert>
    <hr />
    <div class="row align-items-center">
      <div class="col-8">
        <h5 class="result" v-if="totalRows">
          {{ totalRows }} {{ $t("results") }}
        </h5>
      </div>
      <div class="col-4 d-flex align-items-center justify-content-end">
        <div v-if="selected_view === 'table'" class="me-2">
          {{ $t("group-by") }}
        </div>
        <div
          v-if="selected_view === 'table'"
          class="me-2 multiple-options-selection"
        >
          <div
            class="handler d-flex align-items-center justify-content-between form-control"
            @click.stop="toggleGroupByMenu"
          >
            <div class="place-holder">
              {{ group_by_options?.find((each) => each.selected)?.label }}
            </div>
            <img
              :src="require(`@/assets/images/icons/chevron-down.svg`)"
              alt="chevron-down"
              :style="{ transform: open_group_by_menu ? 'rotate(180deg)' : '' }"
            />
          </div>
          <div
            v-if="open_group_by_menu"
            v-click-outside="toggleGroupByMenu"
            class="options p-3"
            :style="
              isLangRtl ? 'left: 0px; width: 180px' : 'right: 0px; width: 180px'
            "
          >
            <div
              v-for="(option, index) in group_by_options"
              :key="index"
              :class="
                index < group_by_options.length - 1
                  ? 'option cursor-pointer mb-2 pb-2'
                  : 'cursor-pointer'
              "
              @click="selectGroupByOption(option)"
            >
              <b v-if="option?.selected">
                {{ option?.label }}
              </b>
              <span v-else>{{ option?.label }}</span>
            </div>
          </div>
        </div>
        <div>
          <base-button
            id="clients_filter_btn"
            variant="secondary"
            class="filter__btn"
            v-b-toggle.sidebar-backdrop
            @mouseenter="filterBtnHovered = true"
            @mouseleave="filterBtnHovered = false"
          >
            <img
              :src="
                filterBtnHovered
                  ? require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                  : require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
              "
              alt="filter"
            />
          </base-button>
        </div>
        <div
          v-if="selected_view === 'table'"
          style="position: relative"
          class="ms-2 multiple-options-selection"
        >
          <base-button
            id="clients_filter_btn"
            variant="secondary"
            class="filter__btn"
            @click="toggleFormBuilder"
          >
            <img
              :src="require(`@/assets/images/icons/form-builder.svg`)"
              alt="form-builder"
              height="16px"
            />
          </base-button>
          <div
            v-if="open_form_builder"
            v-click-outside="toggleFormBuilder"
            class="options p-3"
            :style="
              isLangRtl ? 'left: 0px; width: 220px' : 'right: 0px; width: 220px'
            "
          >
            <div
              v-for="(option, index) in fields"
              :key="index"
              :class="'option d-flex align-items-center cursor-pointer mb-2 pb-2'"
              @click="$emit('selectField', option)"
            >
              <input
                type="checkbox"
                :name="option.key"
                :checked="option.selected"
                :disabled="fields.filter((each) => each.selected).length === 1"
                class="me-2"
              />
              <div>
                {{ option?.label }}
              </div>
            </div>
            <div
              class="d-flex align-items-center cursor-pointer mt-2"
              @click="$emit('resetFieldSelection')"
            >
              <img
                :src="require('@/assets/images/icons/trash-icon.svg')"
                alt="delete image"
                class="me-2"
              />
              <div>
                {{ $t("reset-selection") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "fields",
    "totalRows",
    "selected_view",
    "export_loading",
    "export_error",
  ],
  emits: [
    "quickSearch",
    "selectField",
    "resetFieldSelection",
    "selectView",
    "groupByKey",
    "download",
  ],
  data() {
    return {
      AddBtnHovered: false,
      filterBtnHovered: false,
      open_filter_menu: false,
      open_group_by_menu: false,
      search_text: null,
      select_all: false,
      filter_options: [
        {
          key: "name",
          label: this.$t("english-name"),
          selected: true,
        },
        {
          key: "arabicName",
          label: this.$t("name-in-arabic"),
          selected: false,
        },
        {
          key: "email",
          label: this.$t("email"),
          selected: false,
        },
        {
          key: "phoneNumber",
          label: this.$t("phone-number"),
          selected: false,
        },
        {
          key: "registrationNumber",
          label: this.$t("commercial-registration-number"),
          selected: false,
        },
        {
          key: "vatNumber",
          label: this.$t("client-vat-number"),
          selected: false,
        },
        {
          key: "poiNumber",
          label: this.$t("poi-number"),
          selected: false,
        },
      ],
      group_by_options: [
        {
          key: "none",
          label: this.$t("none"),
          selected: true,
        },
        {
          key: "city",
          label: this.$t("city"),
          selected: false,
        },
        {
          key: "paymentMethod",
          label: this.$t("payment-method"),
          selected: false,
        },
        {
          key: "clientGrade",
          label: this.$t("clients-grade"),
          selected: false,
        },
        {
          key: "type",
          label: this.$t("clients-type"),
          selected: false,
        },
      ],
      open_form_builder: false,
    };
  },
  methods: {
    toggleFormBuilder() {
      this.open_filter_menu = false;
      this.open_group_by_menu = false;
      this.open_form_builder = !this.open_form_builder;
    },
    MoveToAddClient() {
      if (!this.$store.getters["enums/is_not_permitted"]("addClient"))
        this.$router.push("/client/add").catch(() => {});
    },
    selectAllFilterOption() {
      this.select_all = !this.select_all;
      this.filter_options = this.filter_options?.map((each) => {
        each["selected"] = this.select_all;
        return each;
      });
    },
    selectSingleFilterOption(option) {
      this.toggleFilterMenu();
      this.search_text = null;
      this.filter_options = this.filter_options?.map((each) => {
        if (option.key === each.key) each["selected"] = true;
        else each["selected"] = false;
        return each;
      });
    },
    resetFilterSelection() {
      this.search_text = null;
      this.filter_options = this.filter_options?.map((each) => {
        each["selected"] = false;
        return each;
      });
    },
    setValue(val, field) {
      this[field] = val;
    },
    search() {
      this.$emit(
        "quickSearch",
        this.filter_options?.find((each) => each.selected)?.key,
        this.search_text
      );
    },
    toggleFilterMenu() {
      this.open_filter_menu = !this.open_filter_menu;
      this.open_group_by_menu = false;
      this.open_form_builder = false;
    },
    toggleGroupByMenu() {
      this.open_filter_menu = false;
      this.open_group_by_menu = !this.open_group_by_menu;
      this.open_form_builder = false;
    },
    selectGroupByOption(option) {
      this.toggleGroupByMenu();
      this.group_by_options = this.group_by_options?.map((each) => {
        if (option.key === each.key) each["selected"] = true;
        else each["selected"] = false;
        return each;
      });
      this.$emit(
        "groupByKey",
        this.group_by_options?.find((each) => each.selected)?.key
      );
    },
  },
  watch: {
    filter_options(val) {
      if (val?.find((each) => !each.selected)) this.select_all = false;
      else this.select_all = true;
    },
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/clients.json"),
      ar: require("@/services/i18n/locales/ar/clients.json"),
    },
  },
};
</script>

<style lang="scss">
.search-filter-header {
  .search-input-field {
    font-size: 14px;
    letter-spacing: -0.006em;
    color: var(--color-03);
    max-height: 40px;
  }
  .searchOption {
    select {
      background: transparent;
    }
  }
}
</style>
